import React from 'react'
import RealtyType from '../../../models/Realty'
import { Container, NoRealties } from './styles'
import Text from '../../Text'
import Realty from '../Card'

interface Props {
  realties: RealtyType[]
  action?: (realty: RealtyType) => JSX.Element
  emptyAction?: JSX.Element
}

const RealtyList: React.FC<Props> = ({ realties, action, emptyAction }) => {
  if (realties.length > 0) {
    return (
      <Container>
        {realties.map(realty => (
          <Realty
            key={realty.id}
            realty={realty}
          >
            {action && action(realty)}
          </Realty>
        ))}
      </Container>
    )
  }

  return (
    <NoRealties>
      <img
        alt="Placeholder sem imóveis"
        src="/assets/realty-placeholder.png"
      />
      <Text
        tag="span"
        color="gray"
      >
        Nenhum imóvel encontrado
      </Text>
      {emptyAction}
    </NoRealties>
  )
}

export default RealtyList
